export default __webpack_public_path__ + "static/media/HR360.d797845b.svg";